import { Injectable } from '@angular/core';
import { Banner } from '../data/banner.data';

@Injectable({
  providedIn: 'root',
})
export class DomianProviderService {
  getBanner(): Banner {
    const host = window.location.host;
    if (host.includes('shoprite')) return Banner.SHOPRITE;
    if (host.includes('thefreshgrocer')) return Banner.FRESHGROCER;
    if (host.includes('priceritemarketplace')) return Banner.PRICERITE;
    if (host.includes('dearbornmarket')) return Banner.DEARBORN;
    if (host.includes('fairwaymarket')) return Banner.FAIRWAY;
    if (host.includes('gourmetgarage')) return Banner.GOURMETGARAGE;

    return Banner.SHOPRITE;
  }

  getBannerFromParam(bannerParam: string): Banner {
    return Object.values(Banner).includes(bannerParam.toLowerCase() as Banner)
      ? (bannerParam.toLowerCase() as Banner) || Banner.SHOPRITE
      : Banner.SHOPRITE;
  }
}
